import React, { PropsWithChildren } from 'react'
import { View, StyleSheet, ColorValue } from 'react-native'

import Separator from '../../../components/Separator'
import appStyles from '../../../styles/app-styles'
import Colors from '../../../styles/Colors'

type FallbackProps = {
  maxWidth: number
  backgroundColor?: ColorValue
  contentColor?: ColorValue
}
export function PreviewFallback({
  maxWidth,
  backgroundColor,
  contentColor = Colors['layout.gray'],
}: FallbackProps) {
  const borderRadius = (10 / 510) * maxWidth
  return (
    <PaperPagePlaceholder maxWidth={maxWidth} backgroundColor={backgroundColor}>
      <Separator height="12.2%" />
      <View
        // eslint-disable-next-line react-native/no-inline-styles
        style={{
          borderRadius,
          width: '51.7%',
          height: '4.347%',
          backgroundColor: contentColor,
        }}
      />
      <Separator height="10.38%" />
      <View
        style={[
          styles.circle,

          // eslint-disable-next-line react-native/no-inline-styles
          {
            height: '28%',
            backgroundColor: contentColor,
          },
        ]}
      />

      <Separator height="13.2%" />
      <View
        // eslint-disable-next-line react-native/no-inline-styles
        style={{
          borderRadius,
          width: '76.7%',
          height: '4.347%',
          backgroundColor: contentColor,
        }}
      />
      <Separator height="2.74%" />

      <View
        // eslint-disable-next-line react-native/no-inline-styles
        style={{
          borderRadius,
          width: '51.7%',
          height: '4.347%',
          backgroundColor: contentColor,
        }}
      />
    </PaperPagePlaceholder>
  )
}

export function PaperPagePlaceholder({
  maxWidth,
  children,
  backgroundColor = '#F4F4F4',
}: PropsWithChildren<Omit<FallbackProps, 'contentColor'>>) {
  const borderRadius = (10 / 510) * maxWidth
  return (
    <View
      style={[
        styles.page,
        {
          maxWidth,
          borderRadius,
          backgroundColor,
        },
      ]}>
      {children}
    </View>
  )
}

const styles = StyleSheet.create({
  page: {
    ...appStyles.horizontalCenter,
    width: '100%',
    aspectRatio: Math.SQRT1_2,
  },
  circle: {
    aspectRatio: 1,
    borderRadius: 1000,
  },
})
